import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {
  @Input() label: string;
  @Input() color = 'primary';
  @Input() icon: string;
  @Input() iconSlot = 'start';
  @Input() expand = 'block';
  @Input() disabled = false;
  @Input() routerDirection = '';
  @Input() class = '';
  
  constructor() { }

  ngOnInit() { }
}
